"use client";

import { c as _c } from "react/compiler-runtime";
import { isAddressEqual } from "@opensea/utils";
import { ConnectFlowModalContent, useExternalAccount } from "@opensea/wallet";
import { useTranslations } from "next-intl";
import { useState } from "react";
import { ConnectModalActions } from "../../../../../../packages/wallet/src/stores/connectModalStore";
import { LinkWalletChangeDetectedModalContent } from "./LinkWalletChangeDetectedModalContent";
import { SwitchWalletsModalContent } from "./SwitchWalletsModalContent";
export const LinkNewWalletModalContent = t0 => {
  const $ = _c(16);
  const {
    connector,
    setConnector,
    linkedWallets,
    onLinked,
    onLoggedIn
  } = t0;
  const {
    account
  } = useExternalAccount();
  const t = useTranslations("LinkNewWalletModalContent");
  const [isSwitchingAccounts, setIsSwitchingAccounts] = useState(false);
  if (!connector) {
    let t1;
    if ($[0] !== setConnector) {
      t1 = (_address, _chain, connector_0) => {
        setConnector(connector_0);
        ConnectModalActions.reset();
      };
      $[0] = setConnector;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    let t2;
    if ($[2] !== t) {
      t2 = t("linkNewWallet");
      $[2] = t;
      $[3] = t2;
    } else {
      t2 = $[3];
    }
    let t3;
    if ($[4] !== t1 || $[5] !== t2) {
      t3 = <ConnectFlowModalContent isLinking={true} onConnected={t1} switchOnConnect={false} title={t2} />;
      $[4] = t1;
      $[5] = t2;
      $[6] = t3;
    } else {
      t3 = $[6];
    }
    return t3;
  }
  if (account?.address && !linkedWallets.some(lw => isAddressEqual(lw, account.address))) {
    let t1;
    if ($[7] !== account.address || $[8] !== connector || $[9] !== isSwitchingAccounts || $[10] !== onLinked || $[11] !== onLoggedIn) {
      t1 = <LinkWalletChangeDetectedModalContent address={account.address} connector={connector} isSwitchingAccounts={isSwitchingAccounts} onLinked={onLinked} onLoggedIn={onLoggedIn} setIsSwitchingAccounts={setIsSwitchingAccounts} />;
      $[7] = account.address;
      $[8] = connector;
      $[9] = isSwitchingAccounts;
      $[10] = onLinked;
      $[11] = onLoggedIn;
      $[12] = t1;
    } else {
      t1 = $[12];
    }
    return t1;
  }
  const t1 = account?.address;
  let t2;
  if ($[13] !== connector || $[14] !== t1) {
    t2 = <SwitchWalletsModalContent address={t1} fromConnector={connector} />;
    $[13] = connector;
    $[14] = t1;
    $[15] = t2;
  } else {
    t2 = $[15];
  }
  return t2;
};